import { Producto } from '../producto/producto'

/** Preu visible al catàleg (preu − promoció de cesta / promoció). */
export function getCatalogProductEffectivePrice(product: Producto): number {
  const promo =
    product.promocionCesta?.importePromocion ??
    product.promocion?.importePromocion ??
    0
  return Number(product.precio) - Number(promo)
}

function roundPrice(value: number): number {
  return Math.round(value * 100) / 100
}

/**
 * Ajusta el rang del filtre `precio` amb els preus efectius dels productes retornats
 * (resultats visibles de la cerca), perquè el slider reflecteixi el mínim i màxim reals.
 */
export function adjustPrecioFilterWithEffectivePrices<
  T extends Producto
>(availableFilters: Record<string, unknown> | null | undefined, products: T[] | undefined) {
  if (!availableFilters?.precio || !products?.length) return availableFilters

  const precioFilter = availableFilters.precio as {
    min?: number
    max?: number
    [key: string]: unknown
  }

  const effectivePrices = products
    .map(getCatalogProductEffectivePrice)
    .filter((p) => Number.isFinite(p))

  if (!effectivePrices.length) return availableFilters

  const computedMin = Math.min(...effectivePrices)
  const computedMax = Math.max(...effectivePrices)

  return {
    ...availableFilters,
    precio: {
      ...precioFilter,
      min: roundPrice(computedMin),
      max: roundPrice(computedMax),
    },
  }
}
